export default __webpack_public_path__ + "static/media/frflag.448f5a77.svg";